module.exports = "<app-input-field\n  [form]=\"form\"\n  type=\"email\"\n  [id]=\"id\"\n  [controlName]=\"controlName\"\n  [key]=\"key\"\n  [class]=\"class\"\n  [minlength]=\"minlength\"\n  [maxlength]=\"maxlength\"\n  [hideLabel]=\"hideLabel\"\n  [hideErrors]=\"hideErrors\"\n></app-input-field>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-email-field/input-email-field.component.html
// module id = ../../../../../src/app/shared/components/forms/input-email-field/input-email-field.component.html
// module chunks = main